import { render, staticRenderFns } from "./Kraal.vue?vue&type=template&id=b85d2fa6"
import script from "./Kraal.vue?vue&type=script&lang=ts"
export * from "./Kraal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports